import { createContext, useContext, useState, useCallback, useRef, ReactNode } from 'react';

interface CurrencyVisibilityContextType {
  showCurrency: () => void;
  isVisible: boolean;
}

const CurrencyVisibilityContext = createContext<CurrencyVisibilityContextType | undefined>(undefined);

const AUTO_HIDE_DELAY = 3000; // 3초 후 자동 숨김

export function CurrencyVisibilityProvider({ children }: { children: ReactNode }) {
  const [isVisible, setIsVisible] = useState(false);
  const hideTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const showCurrency = useCallback(() => {
    setIsVisible(true);
    
    // 기존 타이머 클리어
    if (hideTimeoutRef.current) {
      clearTimeout(hideTimeoutRef.current);
    }
    
    // 3초 후 자동 숨김
    hideTimeoutRef.current = setTimeout(() => {
      setIsVisible(false);
      hideTimeoutRef.current = null;
    }, AUTO_HIDE_DELAY);
  }, []);

  return (
    <CurrencyVisibilityContext.Provider value={{ showCurrency, isVisible }}>
      {children}
    </CurrencyVisibilityContext.Provider>
  );
}

export function useCurrencyVisibility() {
  const context = useContext(CurrencyVisibilityContext);
  if (context === undefined) {
    throw new Error('useCurrencyVisibility must be used within CurrencyVisibilityProvider');
  }
  return context;
}

